import { AutoTechVehicleViewModel } from "../model/ContractViewModel";

function formatVehicleModel(autoTechData: AutoTechVehicleViewModel) {
  const { manufactureName, modelName } = autoTechData;

  return `${manufactureName} ${modelName}`;
}

export function VehicleModel({
  autoTechData,
}: {
  autoTechData: AutoTechVehicleViewModel;
}) {
  return <span>{formatVehicleModel(autoTechData)}</span>;
}
